import { Route } from 'react-router-dom'
import RegularVDirectPage from '../pages/RegularVDirectPage'

export const RegularPlanRoutes = () => {
  return [<Route path='/regular-plan-alert/:isin' element={<RegularVDirectPage />} />]
}
